<template>
  <div class="home">
    <NavBar/>
    <LandingView/>
    <AboutView/>
    <RobotsView/>
    <SponsorsView/>
    <JoinView/>
    <SubteamsView/>
    <TeamView/>
    <ContactView/>
    <FooterTile/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import LandingView from './LandingView.vue'
import AboutView from './AboutView.vue'
import RobotsView from './RobotsView.vue'
import SponsorsView from './SponsorsView.vue'
import JoinView from './JoinView.vue'
import SubteamsView from './SubteamsView.vue'
import TeamView from './TeamView.vue'
import ContactView from './ContactView.vue'
import FooterTile from '@/components/FooterTile.vue'

export default {
  name: 'HomeView',
  components: {
    NavBar,
    LandingView,
    AboutView,
    RobotsView,
    SponsorsView,
    JoinView,
    SubteamsView,
    TeamView,
    ContactView,
    FooterTile
  },

}
</script>

<style lang="scss">
.home {
  display: flex;
  flex-flow: column nowrap;
}
</style>
